import React, { useState, useEffect, useRef } from 'react';
import ListAll from './ListAll';
import BroadCastList from './BroadCastList';
import NoBroadCastList from './NoBroadCastList';
import ApplicantList from './ApplicantList';
import BlockedList from './BlockedList';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployerList } from '../../../redux/actions/employer/getEmployerList';
import VacancyEmpty from '../Vacancy/VacancyEmpty';
import Skeleton from 'react-loading-skeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getEmployerStats } from '../../../redux/actions/employer/getEmployerStats';
import { resetGetEmployerList } from '../../../redux/slices/employer.slice';

function ContractorList({}) {
  const [checked, setChecked] = useState({});
  const [checkedAll, setCheckedAll] = useState(false);
  const {
    getEmployerList: { data: getEmployerListData, error: getEmployerListError, loading: getEmployerListLoading },
    activeEmployerFilter,
    textEmployerFilter,
    sortEmployerList,
  } = useSelector((state) => state.employer);
  const page = useRef(1);
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const getEmployerListStart = () => {
    page.current = 1;
    setItems([]);
    setChecked({});
    dispatch(getEmployerStats());
    dispatch(getEmployerList({ ...activeEmployerFilter.params, name: textEmployerFilter, page: page.current, ...(sortEmployerList && { ordering: 'id' }) }));
  };
  useEffect(() => {
    getEmployerListStart();
  }, [activeEmployerFilter, textEmployerFilter, sortEmployerList]);

  useEffect(() => {
    return () => {
      dispatch(resetGetEmployerList());
      setItems([]);
    };
  }, []);

  useEffect(() => {
    if (getEmployerListData?.results && !getEmployerListLoading) {
      setItems((prev) => {
        return [
          ...prev,
          ...getEmployerListData?.results?.map((item) => ({
            verification: item?.verification,
            key: item.id,
            num: item.id,
            name: item.name,
            email: item.email,
            active: item.broadcast_vacancies,
            activeHR: item.broadcast_hr,
            moderation: item.moderation_vacancies,
            inactive: item.inactive_vacancies,
            delete: item.deleted_vacancies,
          })),
        ];
      });
      let checkedNew = {};
      getEmployerListData?.results?.map((item) => {
        checkedNew = { ...checkedNew, [item.id]: false };
      });
      setChecked((prev) => ({ ...prev, ...checkedNew }));
    }
  }, [getEmployerListData, getEmployerListLoading]);

  useEffect(() => {
    if (checkedAll) {
      setChecked((prev) => Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: true }), {}));
    } else {
      setChecked((prev) => Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}));
    }
  }, [checkedAll]);
  const showAction = !!Object.keys(checked)
    .map((key) => checked[key])
    .filter((item) => item)?.length;

  return (
    <div className="flex flex-col w-full">
      <div className="overflow-y-auto">
        <div className="p-2 min-w-full inline-block align-middle">
          <div className="border rounded-lg overflow-hidden">
            <>
              {getEmployerListLoading && !items?.length ? (
                <></>
              ) : items?.length ? (
                <InfiniteScroll
                  dataLength={items.length}
                  next={() => {
                    if (getEmployerListData?.next) {
                      page.current += 1;

                      dispatch(getEmployerList({ ...activeEmployerFilter.params, name: textEmployerFilter, page: page.current, ...(sortEmployerList && { ordering: 'id' }) }));
                    }
                  }}
                  hasMore={true}>
                  {activeEmployerFilter?.value === 'all' ? (
                    <ListAll currentItems={items} />
                  ) : activeEmployerFilter?.value === 'broadcast' ? (
                    <BroadCastList currentItems={items} />
                  ) : activeEmployerFilter?.value === 'noBroadcast' ? (
                    <NoBroadCastList currentItems={items} checked={checked} setChecked={setChecked} showAction={showAction} checkedAll={checkedAll} setCheckedAll={setCheckedAll} onStartFetch={getEmployerListStart} />
                  ) : activeEmployerFilter?.value === 'applicant' ? (
                    <ApplicantList currentItems={items} checked={checked} setChecked={setChecked} showAction={showAction} checkedAll={checkedAll} setCheckedAll={setCheckedAll} onStartFetch={getEmployerListStart} />
                  ) : (
                    <BlockedList currentItems={items} checked={checked} setChecked={setChecked} showAction={showAction} checkedAll={checkedAll} setCheckedAll={setCheckedAll} onStartFetch={getEmployerListStart} />
                  )}
                </InfiniteScroll>
              ) : (
                <VacancyEmpty>Список пуст</VacancyEmpty>
              )}
            </>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContractorList;
